import axios from 'axios';
import { API_BASE_URL, SECRET_NAME_FOR_BUCKET } from '../../redux/constants/index';

class SecretsManagerService {

    getSecretValues() {
      return axios.get(API_BASE_URL + `SecretsManager/GetSecretsManager?bucket_secret=${SECRET_NAME_FOR_BUCKET}`);
    }
    getDecryptSecretValues(object) {
      return axios.post(API_BASE_URL + "SecretsManager/GetDecyptecSecretsManager" , {
        bucket_name_stag: object.bucket_name_stag,
        access_key_id: object.access_key_id,
        secret_access_key: object.secret_access_key,
        bucket_name_prod: object.bucket_name_prod
      });
    }
  }
  
  export default new SecretsManagerService();